import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Card } from 'react-bootstrap'

class ClaimsView extends Component {		

	render() {		

		return (<Card className="claims">
			<Card.Body>
				<Card.Title>Claims</Card.Title>
				<table className="table">
					<thead>
						<tr>
							<th>Claim type</th>
							<th>Claim value</th>
						</tr>
					</thead>
					<tbody>
						{this.props.claims.map(c => { return (<tr key={c.type}><td>{c.type}</td><td>{c.value}</td></tr>); })}
					</tbody>
				</table>
			</Card.Body>
		</Card>);
	}
}

const mapStateToProps = (state) => {
	return {
		...state.action.actionData,
	};
};

export default connect(
	mapStateToProps,
	dispatch => bindActionCreators({}, dispatch)
)(ClaimsView);



// WEBPACK FOOTER //
// ./src/components/Claims/ClaimsView.js